import _ from 'lodash';
import { RldConstant } from '../components/RldTool/RldConstant';

export const encodeObjToQueryParam = obj => {
  const sq = _.cloneDeep(obj);
  Object.keys(sq).map(k => {
    if (!sq[k] || _.isEmpty(sq[k])) {
      delete sq[k];
    }
    return false;
  });
  return Object.entries(sq)
    .map(e => e.join('='))
    .join('&');
};

export const AddFieldsToAccount = accounts => {
  const newAccounts = [];

  _.map(accounts, account => {
    const isTPP = account.accountType === 'TPP' ? true : false;
    if (
      newAccounts.find(
        a =>
          a.label ==
          (isTPP
            ? account.accountName + ' ' + '(Third Party)'
            : account.accountName)
      ) == null
    ) {
      newAccounts.push({
        ...account,
        label: isTPP
          ? account.accountName + ' ' + '(Third Party)'
          : account.accountName,
        value: account.accountId,
      });
    }
  });
  return newAccounts;
};

export const multipleEmailValidation = emails => {
  let emailList = ArrayEmailParse(emails);
  let badEmails = [];
  let badDomainsEmails = [];
  let invalidEmails = [];

  emailList.map(email => {
    if (email.trim().length > 0) {
      let validate = validateDomain(email.trim());
      switch (validate) {
        case 1: {
          invalidEmails.push(email);
          break;
        }
        case -1: {
          badDomainsEmails.push(email);
          break;
        }
        default:
          break;
      }
    }
  });

  badDomainsEmails =
    badDomainsEmails.length > 0
      ? [
          `Please re-enter using the permitted email domains(${RldConstant.emailDomains.join(
            ','
          )}): `,
          ...badDomainsEmails,
        ]
      : badDomainsEmails;

  invalidEmails =
    invalidEmails.length > 0
      ? [`Invalid Email: `, ...invalidEmails]
      : invalidEmails;

  badEmails = [...badDomainsEmails, ...invalidEmails];

  return badEmails;
};

export const validateDomain = email => {
  var emailValidate = rldEmailValidate(email);
  return emailValidate
    ? RldConstant.emailDomains.find(a =>
        email.toLowerCase().trim().endsWith(a.toLowerCase().trim())
      ) == null
      ? -1 // domain
      : 0 // good
    : 1; // bad email
};

export const rldEmailValidate = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateMultipleEmails = emails => {
  let c = RldConstant.emailDomains.join('|').replace(/\./g, '\\.');
  let re = new RegExp(
    '^(([a-zA-Z0-9_\\-\\.]+)@('.concat(c).concat(')(\\s*(;|,)\\s*|\\s*))+$')
  );
  // const re = /^(([a-zA-Z0-9_\-\.]+)@(gfk\.com|mrisimmons\.com)(\s*(;|,)\s*|\s*))+$/;
  return re.test(String(emails).toLowerCase());
};

export const ArrayEmailParse = emails => {
  let emailList =
    emails.length > 0
      ? emails.replace(/;/g, '\n').replace(/,/g, '\n').split('\n')
      : [];

  return emailList;
};

export const ArrangeEmails = emails => {
  let emailParseList = ArrayEmailParse(emails);
  let emailList = [];

  emailParseList.map(email => {
    if (email.trim().length > 0) {
      emailList.push(email.trim());
    }
  });

  return emailList;
};

export const checkDigitsTimeStamp = timestamp => {
  const newTimestamp =
    timestamp.toString() && timestamp.toString().length === 1
      ? `0${timestamp}`
      : `${timestamp}`;

  return newTimestamp;
};

export const exportFileTitle = () => {
  const date = new Date();
  const month = date.getMonth() + 1;

  const dateFormat = `${checkDigitsTimeStamp(month)}-${checkDigitsTimeStamp(
    date.getDate()
  )}-${date.getFullYear()}`;
  const timeFormat = `${checkDigitsTimeStamp(
    date.getHours()
  )}${checkDigitsTimeStamp(date.getMinutes())}${checkDigitsTimeStamp(
    date.getSeconds()
  )}`;

  const title = `${dateFormat}_${timeFormat}`;
  return title;
};
